// @ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import moment from "moment";

import { getBusTimetable } from "../data/apiClient";

const Buses: React.FC<{ data: any }> = ({
    data,
}) => {
    const [timetable, setTimetable] = useState([]);
    const [showDetails, setShowDetails] = useState(false);
    const [lastUpdated, setLastUpdated] = useState<null | Date>(null);

    useEffect(() => {
        const controller = new AbortController();
        const { signal } = controller;

        loadBuses(signal);
        const interval: any = setInterval(() => {
            loadBuses(signal);
        }, 30000);

        return () => {
            controller.abort();
            clearInterval(interval);
        }
    }, [data.atcoCode]);

    const loadBuses = (signal: AbortSignal) => {
        if (data.atcoCode) getBusTimetable(signal, data.atcoCode).then((response) => {
            let sorted = response.sort((a, b) => a.aimedDepartureTime > b.aimedDepartureTime);
            setTimetable(sorted);
            setLastUpdated(new Date());
        });
    }

    const getDepartureStatus = (status: string, expectedLeave: string): string => {
        switch (status) {
            case "onTime":
                return "On Time";
            case "delayed":
                return "Exp: " + moment(expectedLeave).format("HH:mm");
            case "early":
                return "Early";
            default:
                return status;
        }
    }

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
        }}>
            {lastUpdated ? <h4 style={{ marginRight: "1.5rem", fontSize: 14, textAlign: "right", color: "#999" }}>Last Updated {moment(lastUpdated).format("HH:mm")}</h4> : null}

            <h4 style={{ margin: "1rem", marginLeft: "1.5rem", marginTop: "0.5rem", fontSize: 24, textAlign: "center" }}>{data.commonName}</h4>

            {showDetails && <div
                style={{
                    width: "100%"
                }}
                onScroll={e => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
            >
                {timetable.map((d, i) => {
                    return (
                        <div
                            key={d.expectedDepartureTime + d.line + d.destinationName}
                            style={{
                                backgroundColor: (i % 2 == - 0) ? "#FAFAFA" : "transparent",
                                paddingTop: "0.5rem",
                                paddingBottom: "0.5rem",
                                width: "100%",
                                paddingLeft: "1.5rem",
                                paddingRight: "1.5rem",
                                boxSizing: "border-box",
                            }}
                        >
                            <div
                                style={{
                                    justifyContent: "space-between",
                                    display: "flex",
                                    flexDirection: "row-reverse",
                                    color: "black",
                                    fontSize: "19px",
                                    paddingBottom: "4px",

                                }}
                            >
                                <div>
                                    {moment(d.aimedDepartureTime).format("HH:mm")}
                                </div>
                                <div style={{ display: "flex" }}>
                                    {d.line}
                                    {d.isMonitored ? (
                                        <div style={{
                                            backgroundColor: "#EF4444",
                                            color: "white",
                                            borderRadius: 3,
                                            paddingLeft: 10,
                                            paddingRight: 10,
                                            marginLeft: 10,
                                        }}>Live</div>
                                    ) : null}
                                </div>
                            </div>

                            <div
                                style={{
                                    justifyContent: "space-between",
                                    display: "flex",
                                    flexDirection: "row",
                                    color: "black",
                                    fontSize: "19px",
                                    paddingBottom: "4px",

                                }}
                            >
                                <div>{d.destinationName}</div>
                                <div style={{ color: "#3098fc" }}>{getDepartureStatus(d.departureStatus, d.expectedDepartureTime)}</div>
                            </div>
                        </div>
                    );
                })}
            </div>}

            <div style={{ padding: "1rem", textAlign: "center", color: "#1EA7FD", fontSize: 18, fontWeight: 500 }} onClick={() => setShowDetails(prev => !prev)}>{showDetails ? "Hide Bus Times" : "Show Bus Times"}</div>
        </div>
    );
};

export default Buses;
